<template>
  <div class="password-strength">
    <div v-if="password" class="password-strength-tip">
      密码强度：
      <b
        :class="{
          height: strength === 3,
          medium: strength === 2,
          low: strength === 1
        }"
      >
        {{ strength === 3 ? '高' : strength === 2 ? '中' : '低' }}
      </b>
      <!-- <span v-show="strength === 2">（推荐）</span> -->
    </div>
    <div class="password-strength-bar">
      <div :class="{ active: strength >= 1 }"></div>
      <div :class="{ active: strength >= 2 }"></div>
      <div :class="{ active: strength === 3 }"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'password-strength',
    props: {
      password: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        strength: 0
      };
    },
    watch: {
      password: {
        handler(newVal) {
          if (!newVal) {
            this.strength = 0;
            this.$emit('on-change', this.strength);
            return;
          } else if (newVal.length < 8) {
            this.strength = 1;
            this.$emit('on-change', this.strength);
            return;
          }
          let hasNum = 0;
          let hasWord = 0;
          let hasSpecChar = 0;
          for (let i = 0; i < newVal.length; i++) {
            if (hasNum === 0 && /[0-9]/.test(newVal[i])) {
              hasNum++;
            } else if (hasWord === 0 && /[a-zA-Z]/.test(newVal[i])) {
              hasWord++;
            } else if (hasSpecChar === 0 && /[@#￥!^&*()]/.test(newVal[i])) {
              hasSpecChar++;
            }
          }
          if (hasNum + hasWord + hasSpecChar < 2) {
            this.strength = 1;
          } else if (hasNum + hasWord + hasSpecChar === 2) {
            this.strength = 2;
          } else if (hasNum + hasWord + hasSpecChar === 3) {
            this.strength = 3;
          }
          this.$emit('on-change', this.strength);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .password-strength {
    width: 100%;
    margin: 16px 0 8px;
    .password-strength-tip {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      font-size: 12px;
      span {
        color: #666;
      }
      .low {
        color: #ff0000;
      }
      .medium {
        color: #ff7200;
      }
      .height {
        color: #3fd662;
      }
    }
    .password-strength-bar {
      display: flex;
      list-style: none;
      div {
        flex: 1;
        height: 4px;
        border-radius: 4px;
        opacity: 0.2;
        transition: all 0.2s linear;
        & + div {
          margin-left: 2px;
        }
        &.active {
          opacity: 1;
        }
        &:first-child {
          background: #ff0000;
        }
        &:nth-child(2) {
          background: #ff7200;
        }
        &:last-child {
          background: #3fd662;
        }
      }
    }
  }
</style>
